<aside [ngClass]="sidenavClass()">
  <!-- Header Section -->
  <div class="sidenav-header">
    <div class="logo">
      <div class="logo-icon">
        <ng-icon name="heroShieldCheckSolid" size="24"></ng-icon>
      </div>
      <div class="logo-text">TRACPASS</div>
    </div>
  </div>

  <!-- Navigation Menu -->
  <nav class="sidenav-nav">
    <ul class="menu-list">
      @for (item of menuItems(); track item.id) {
        <li class="menu-item">
          <button
            (click)="selectMenuItem(item.id)"
            [class]="'menu-link ' + (item.active ? 'menu-link--active' : '')"
            [pTooltip]="isCollapsed() ? item.label : ''"
            tooltipStyleClass="sidenav-tooltip"
            tooltipPosition="right"
            type="button"
            pRipple
          >
            <ng-icon [name]="item.icon" size="18" class="menu-icon"></ng-icon>
            <div class="menu-label">{{ item.label }}</div>
          </button>
        </li>
      }
    </ul>
  </nav>

  <!-- Footer Section with Collapse Toggle -->
  <div class="sidenav-footer">
    <button
      (click)="toggleSidenav()"
      class="toggle-btn"
      [pTooltip]="isCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      tooltipStyleClass="sidenav-tooltip"
      tooltipPosition="right"
      type="button"
    >
      <ng-icon
        [name]="isCollapsed() ? 'heroChevronRight' : 'heroChevronLeft'"
        size="14"
      ></ng-icon>
    </button>
  </div>
</aside>
<div class="sidenav-overlay" [ngClass]="{'sidenav-overlay--collapsed': isCollapsed()}" (click)="collapseOnOverlayClick()"></div>